
import { Component, Inject, Vue } from "vue-property-decorator";
import { Container } from "inversify";
import Modal from "../../../../common/src/components/Modal.vue";
import FormCheckbox from "../../../../landing/src/molecules/form/FormCheckbox.vue";
import ActionButton from "../../../../common/src/components/ActionButton.vue";
import { ProfileStore } from "../../../../landing/src/stores/member/profile/ProfileStore";
import { AuthStore } from "../../../../common/src/stores/AuthStore";
@Component({
    components: {
        FormCheckbox,
        Modal,
        ActionButton,
    },
})
export default class TermsConditionModal extends Vue {
    @Inject("container") readonly container!: Container;
    readonly profileStore: ProfileStore = this.container.get(ProfileStore);
    readonly authStore: AuthStore = this.container.get(AuthStore);

    async submit() {
        if (this.profileStore.data.termsAccepted) {
            await this.profileStore.submit();
            await this.authStore.me();
        }
    }
}
